import React from 'react';
import classNames from 'classnames';

const TagCard = ({
  id,
  name = '',
  qaCount = 0,
  qas = [],
  onClick = () => {}
}) => {
  const classes = classNames({
    'tags-item': true
  });

  return (
    <div className={classes} onClick={onClick}>
      <div className="tags-item-name">{name}</div>
      <div className="tags-item-qa-count">{qaCount} kpl</div>
      {qas && qas[0] && <div className="tags-item-qas">{qas[0].text}</div>}
    </div>
  );
};

export default TagCard;
